import showDifmPrivacyUpsell from './show-difm-privacy-upsell';

export default {
  showDifmPrivacyUpsell,
};
